export default __webpack_public_path__ + "static/media/Atmos.3bd3e860.png";